import dayjs from 'dayjs';
import { Order, OrderMonitor } from '../../../types/orderTypes';

export function formatWindowInterval(order: Order | OrderMonitor): string {
  return `${dayjs(order.deliverFrom).format('HH:mm')} - ${dayjs(
    order.deliverUntil
  ).format('HH:mm')}`;
}

export function formatTimeSeconds(seconds: number): string {
  let hours: string | number = Math.floor(seconds / 3600);
  let minutes: string | number = Math.floor((seconds - hours * 3600) / 60);
  let secs: string | number = seconds - hours * 3600 - minutes * 60;
  if (hours < 10) {
    hours = `0${hours}`;
  }
  if (minutes < 10) {
    minutes = `0${minutes}`;
  }
  if (secs < 10) {
    secs = `0${secs}`;
  }
  return `${hours}:${minutes}:${secs}`;
}
